module.exports = __webpack_public_path__ + "media/demo1-kr.d922a100.mp4";